import React from 'react';
import * as ST from './styled';

export const SubscriptionCard = ({ data }) => {
    return (
        <ST.SubscriptionCard bgColor='#000'>
            <ST.StyledLink href={data.href} rel='nofollow noopener noreferrer'>
                <ST.ImgWrap>
                    <ST.Img src={data.src} alt=''/>
                </ST.ImgWrap>
            </ST.StyledLink>

            <ST.DataLink href={data.href} rel='nofollow noopener noreferrer'>
                {data.title}
            </ST.DataLink>
            <ST.DataText isLight>{data.text}</ST.DataText>
            <ST.Cost isLight>{data.cost}</ST.Cost>
        </ST.SubscriptionCard>
    );
};
